import { useTranslation } from 'react-i18next';

import Banner from '../Banner';
// import RecommendedCarousel from '../RecommendedCarousel';

// Styles
import styles from './index.module.sass';

// Image
import Product1 from '../../images/home/product1.jpg';

const location = process.env.REACT_APP_COUNTRY;

export default function ConsultancyHome({ device = {} }) {
  const { screenSize } = device;
  const { t } = useTranslation('consultancyhome');

  const promo1 = t('promo1', { returnObjects: true });
  const promo2 = t('promo2', { returnObjects: true });

  return (
    <div id={styles.Home} className={styles[screenSize]}>
      <Banner device={device} />
      {/* <RecommendedCarousel device={device} /> */}
      <div className={`${styles.promo} ${styles.left}`}>
        <div className={`${styles.promoTextContainer} ${styles.promoLeft}`}>
          <div className={styles.cursiveBlue}>{promo1.text1}</div>
          <div className={styles.capitalBlue}>{promo1.text2}</div>
          <div className={styles.capitalGold}>{promo1.text3}</div>
          <div className={styles.descriptionText}>{promo1.text4}</div>
        </div>
        <div className={styles.promoImageContainer}>
          <img src={Product1} alt='' className={styles.promoImage} />
        </div>
      </div>

      {location === 'US' && (
        <div className={`${styles.promo} ${styles.right}`}>
          <div className={styles.promoImageContainer}>
            <img
              src='https://webimages.terramarbrands.com.mx/usawebpage/home/producto-estrella-usa-2.jpg'
              alt=''
              className={styles.promoImage}
            />
          </div>
          <div className={`${styles.promoTextContainer} ${styles.promoRight}`}>
            <div className={styles.capitalGold}>{promo2.text1}</div>
            <div className={styles.cursiveBlue}>{promo2.text2}</div>
            <div className={styles.descriptionText}>{promo2.text3}</div>
          </div>
        </div>
      )}
    </div>
  );
}
